import React from "react";
import _get from "lodash/get";
import clsx from "clsx";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
} from "@material-ui/core";
import priceWithVAT from "../helpers/priceWithVAT";
import toLocale from "../helpers/toLocale";
import { withStyles, makeStyles } from "@material-ui/core/styles";


const PricingTable = ({
  priceData,
  ecoBonus,
  discountPercentage
}) => {

/*

client_invoice_no_vat : "32126.81"
client_invoice_with_vat: "38230.9"
ecobonus_value: "0"
final_offer_price_with_vat: "38230.9"
total_advantage_no_vat: "7012.19"
total_advantage_with_vat: "8344.51"
total_price_no_vat: "39139.00"
total_price_with_vat: "46575.41"

  * * */
  const classes = useStyles();
  // Calculations
  const dealerBonus = _get(priceData, "total_advantage_no_vat", '');
  const dealerBonusWithVat = _get(priceData, "total_advantage_with_vat", '');
  const recommendedPrice = _get(priceData, "total_price_no_vat", '');
  const recommendedWithVat = _get(priceData, "total_price_with_vat", '');

  const ourPrice = _get(priceData, "client_invoice_no_vat", '');
  const ourPriceWithVat = _get(priceData, "client_invoice_with_vat", '');

  const promoPrice = _get(priceData, "final_offer_price_with_vat", '');

  //   const formatPrice = (price) => `${price.toLocaleString('ro-RO', {minimumFractionDigits: 0, maximumFractionDigits: 0})}€`;

  const StyledTableCell = withStyles((theme) => ({
    root: {
      "&": {
        border: "none",
      },
    },
    head: {

    },
    body: {
      fontSize: theme.typography.pxToRem(14),

    },
  }))(TableCell);

  const StyledTableRow = withStyles((theme) => ({
    root: {
      "&": {
        border: 'none',
        borderBottom: "7px solid #F9F9F9",
      },
    },
  }))(TableRow);

  return (
    <TableContainer className={classes.root}>
      <Table size="small" className={classes.table}>
        <TableHead>
          <StyledTableRow>
            <StyledTableCell></StyledTableCell>
            <StyledTableCell align="right">
              <Typography variant="body1" className={clsx(classes.tableCell)}>Euro fara TVA</Typography>
            </StyledTableCell>
            <StyledTableCell align="right">
              <Typography variant="body1" className={clsx(classes.tableCell)}>Euro cu TVA</Typography>
            </StyledTableCell>
          </StyledTableRow>
        </TableHead>
        <TableBody>
          <StyledTableRow>
            <StyledTableCell>
              <Typography variant="body1" className={clsx(classes.tableCell, classes.bold)}>
                Preț recomandat
              </Typography>
            </StyledTableCell>
            <StyledTableCell align="right">
              <Typography variant="body1" className={clsx(classes.tableCellXs, classes.bold)}>
                {toLocale(recommendedPrice)}€
              </Typography>
            </StyledTableCell>
            <StyledTableCell align="right">
              <Typography variant="body1" className={clsx(classes.tableCell, classes.bold)}>
                {toLocale(recommendedWithVat)}€
              </Typography>
            </StyledTableCell>
          </StyledTableRow>
          {dealerBonus && Number(dealerBonus) !== 0 && <StyledTableRow>
            <StyledTableCell>
              <Typography variant="body1" className={clsx(classes.tableCell, classes.bold)}>
                Avantaj client 
              </Typography>
            </StyledTableCell>
            <StyledTableCell align="right">
              <Typography variant="body1" className={clsx(classes.tableCellXs, classes.bold)}>
                {toLocale(dealerBonus)}€
              </Typography>
            </StyledTableCell>
            <StyledTableCell align="right">
              <Typography variant="body1" className={clsx(classes.tableCell, classes.bold)}>
                {toLocale(dealerBonusWithVat)}€
              </Typography>
            </StyledTableCell>
          </StyledTableRow>}
          <StyledTableRow style={{ borderRadius: "16px" }}>
            <StyledTableCell style={{ backgroundColor: "#D6D6D6", paddingBottom: 6, borderTopLeftRadius: '15px', borderBottomLeftRadius: '15px', }}>
              <Typography variant="body1" className={clsx(classes.tableCell, classes.bold)}>
                Oferta noastră
              </Typography>
            </StyledTableCell>
            <StyledTableCell align="right" style={{ backgroundColor: "#D6D6D6", paddingBottom: 6 }}>
              <Typography variant="body1" className={clsx(classes.tableCellXs, classes.bold)}>
                {toLocale(ourPrice)}€
              </Typography>
            </StyledTableCell>
            <StyledTableCell align="right" style={{ backgroundColor: "#D6D6D6", paddingBottom: 6, borderTopRightRadius: '15px', borderBottomRightRadius: '15px', }}>
              <Typography variant="body1" className={clsx(classes.tableCell, classes.bold)}>
                {toLocale(ourPriceWithVat)}€
              </Typography>
            </StyledTableCell>
          </StyledTableRow>
          {ecoBonus && <StyledTableRow style={{ borderRadius: "16px" }}>
            <StyledTableCell style={{ backgroundColor: "#D6D6D6", paddingBottom: 6, borderTopLeftRadius: '15px', borderBottomLeftRadius: '15px', }}>
              <Typography variant="body1" className={clsx(classes.tableCell, classes.bold)}>
                Valoare Volvo Ecobonus<sup>1</sup>
              </Typography>
            </StyledTableCell>
            <StyledTableCell align="right" colSpan={2} style={{ backgroundColor: "#D6D6D6", paddingBottom: 6, borderTopRightRadius: '15px', borderBottomRightRadius: '15px', }}>
              <Typography variant="body1" className={clsx(classes.tableCellXs, classes.bold)}>
                {toLocale(ecoBonus)}€
              </Typography>
            </StyledTableCell>
          </StyledTableRow>}
          {ecoBonus && <StyledTableRow>
            <StyledTableCell>
              <Typography variant="subtitle1" color="primary">
                <Typography variant="subtitle1" color="primary" className={clsx(classes.tableCell, classes.bold)}>
                  Preț promo
                </Typography>
              </Typography>
            </StyledTableCell>
            <StyledTableCell align="right" colSpan={2}>
              <Typography variant="subtitle1" color="primary" className={clsx(classes.tableCell, classes.bold)}>
                {toLocale(promoPrice)}€
              </Typography>
            </StyledTableCell>
          </StyledTableRow>}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: "#F9F9F9",
    borderRadius: theme.spacing(2),
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
  },
  table: {
    width: "100%",
    // borderCollapse:"separate"
  },
  bold: {
    fontWeight: theme.typography.fontWeightMedium,
  },

  white: {
    background: "#fff",
  },

  thumbRoot: {
    paddingLeft: theme.spacing(2),
    paddingRight: theme.spacing(2),
    paddingBottom: theme.spacing(2),
    paddingTop: theme.spacing(2),
  },

  thumbImage: {
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    width: "100%",
    height: "100%",
    opacity: 0.4,
    transition: theme.transitions.create(["opacity"], {
      easing: theme.transitions.easing.easeOut,
      duration: theme.transitions.duration.enteringScreen,
    }),
    ".swiper-slide-thumb-active &": {
      opacity: 1,
    },
  },

  tableCell: {
    fontSize: theme.typography.pxToRem(14),
  },
  tableCellXs: {
    fontSize: theme.typography.pxToRem(14),
  },

  text: {
    letterSpacing: 0,
    fontWeight: theme.typography.fontWeightLight,
    fontSize: theme.typography.pxToRem(18),
    lineHeight: theme.typography.pxToRem(24),
    [theme.breakpoints.down("sm")]: {
      fontSize: theme.typography.pxToRem(16),
    },
    "&$bottomSpacing": {
      marginBottom: theme.spacing(2),
    },
  },

  headerTitle: {
    fontSize: `1.125rem`,
    fontWeight: 500,
    lineHeight: `1.5rem`,
    overflow: `hidden`,
    textOverflow: `ellipsis`,
    display: `-webkit-box`,
    lineClamp: 3,
    boxOrient: `vertical`,
    [theme.breakpoints.down("sm")]: {
      marginRight: theme.spacing(0),
      fontSize: theme.typography.pxToRem(14),
      lineHeight: theme.typography.pxToRem(20),
    },
  },
}));

export default PricingTable;
